 export class Account {
     constructor(BusinessName) {
        this.BusinessName = BusinessName;
    }

}
